import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../services/user/models/user.model';
import { AuthenticationService } from '../../../core/services/authentication/authentication.service';
import { Router } from '@angular/router';
import { UtilityService } from '../../services/utility/utility.service';

@Component({
  selector: 'upsc-user-block',
  templateUrl: './user-block.component.html',
  styleUrls: ['./user-block.component.scss'],
})
export class UserBlockComponent implements OnInit {
  @Input() user: User;

  public greetingKey = 'Welcome';

  constructor(private router: Router,
              private utilityService: UtilityService,
              private authenticationService: AuthenticationService) {
  }

  public ngOnInit() {
    this.greetingKey = this.utilityService.getGreetingTime();
  }

  public getUserInitial() {
    let initial = '?';
    if (!this.user) {
      return initial;
    }

    const initialOptions = [
      this.user.FirstName,
      this.user.LastName,
      this.user.UserName,
    ];

    for (const option of initialOptions) {
      if (!option || option.trim() === '') {
        continue;
      }

      initial = option.charAt(0);
      break;
    }

    return initial;
  }

  public navigateTo(routePath: string) {
    this.router.navigate([routePath]);
  }

  public logout() {
    this.authenticationService.logout();
  }
}
